<template>
  <div class="pattern-block tutorial" :class="`size-3`">
    <div class="description-box">
      <span>{{ steps[step].description }}</span>
    </div>
    <div class="time-box">
      <div v-if="steps[step].countDown" :style="gradient" class="time">
        <span>{{ steps[step].countDown }}</span>
      </div>
    </div>
    <div v-for="row in 3" :key="`row${row}`" class="row">
      <div v-for="column in 3" :key="`column${column}`" class="column">
        <div
          class="item"
          :class="[
            {
              mark: isMarked(row, column),
            },
            {
              fail: isFail(row, column),
            },
          ]"
        ></div>
      </div>
    </div>

    <div class="start-game">
      <el-button v-if="steps[step].countDown" type="primary">{{
        $t("test.btnStartGame")
      }}</el-button>
    </div>

    <div class="control-step">
      <div>
        <el-button
          @click="backStep"
          v-if="step > 0 && step < steps.length - 1"
          type="text"
          ><i class="fas fa-angle-left"></i>
          {{ $t("tutorial.btnBack") }}</el-button
        >
      </div>
      <div v-if="step < steps.length - 1">
        <el-button @click="$emit('exitTutorial')" type="text" size="medium">
          {{ $t("tutorial.btnBack") }} <i class="fas fa-angle-right"></i
          ><i class="fas fa-angle-right"></i
        ></el-button>
        <el-divider direction="vertical"></el-divider>
        <el-button @click="nextStep" type="text">
          {{ $t("tutorial.btnBack") }} <i class="fas fa-angle-right"></i
        ></el-button>
      </div>
      <div v-else>
        <el-button @click="$emit('exitTutorial')" type="text"
          >{{ $t("test.btnStartGame") }} <i class="fas fa-angle-right"></i
        ></el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pattern: {
      type: Object,
      default: null,
    },
  },
  computed: {
    gradient() {
      return {
        background: `conic-gradient(#FF9B57 0%, #FF9B57 ${
          this.steps[this.step].countDown * 10
        }%, #FFDAC1 ${this.steps[this.step].countDown * 10}%, #FFDAC1 0%)`,
      };
    },
  },
  data() {
    return {
      step: 0,
      steps: [
        {
          step: 0,
          positions: [],
          description: this.$t("tutorialSpatialSpan.step0"),
          countDown: null,
          lifePoints: 3,
          fail: {
            row: null,
            column: null,
          },
        },
        {
          step: 1,
          positions: [
            { row: 1, column: 1 },
            { row: 2, column: 2 },
            { row: 3, column: 2 },
          ],
          description: this.$t("tutorialSpatialSpan.step1"),
          countDown: null,
          lifePoints: 3,
          fail: {
            row: null,
            column: null,
          },
        },
        {
          step: 2,
          positions: [
            { row: 1, column: 1 },
            { row: 2, column: 2 },
            { row: 3, column: 2 },
          ],
          description: this.$t("tutorialSpatialSpan.step2"),
          countDown: 10,
          lifePoints: 3,
          fail: {
            row: null,
            column: null,
          },
        },
        {
          step: 3,
          positions: [
            { row: 1, column: 1 },
            { row: 2, column: 2 },
            { row: 3, column: 2 },
          ],
          description: this.$t("tutorialSpatialSpan.step3"),
          countDown: 1,
          lifePoints: 3,
          fail: {
            row: null,
            column: null,
          },
        },
        {
          step: 4,
          positions: [],
          description: this.$t("tutorialSpatialSpan.step4"),
          countDown: null,
          lifePoints: 3,
          fail: {
            row: null,
            column: null,
          },
        },
        {
          step: 5,
          positions: [],
          description: this.$t("tutorialSpatialSpan.step5"),
          countDown: null,
          lifePoints: 3,
          fail: {
            row: null,
            column: null,
          },
        },
        {
          step: 6,
          positions: [],
          description: this.$t("tutorialSpatialSpan.step6"),
          countDown: null,
          lifePoints: 2,
          fail: {
            row: 1,
            column: 2,
          },
        },
        {
          step: 7,
          positions: [],
          description: this.$t("tutorialSpatialSpan.step7"),
          countDown: null,
          lifePoints: 0,
          fail: {
            row: 1,
            column: 3,
          },
        },
        {
          step: 8,
          positions: [],
          description: this.$t("tutorialSpatialSpan.step8"),
          countDown: null,
          lifePoints: 2,
          fail: {
            row: null,
            column: null,
          },
        },
        {
          step: 9,
          positions: [
            { row: 1, column: 1 },
            { row: 1, column: 3 },
            { row: 3, column: 2 },
          ],
          description: this.$t("tutorialSpatialSpan.step9"),
          countDown: null,
          lifePoints: 2,
          fail: {
            row: null,
            column: null,
          },
        },
        {
          step: 10,
          positions: [
            { row: 1, column: 1 },
            { row: 1, column: 3 },
            { row: 3, column: 2 },
          ],
          description: this.$t("tutorialSpatialSpan.step10"),
          countDown: null,
          lifePoints: 2,
          fail: {
            row: null,
            column: null,
          },
        },
      ],
    };
  },
  methods: {
    nextStep() {
      this.step++;
      this.$emit("setLifePoints", this.steps[this.step].lifePoints);
    },
    backStep() {
      this.step--;
      this.$emit("setLifePoints", this.steps[this.step].lifePoints);
    },
    skip() {
      this.$emit("exitTutorial");
    },
    isMarked(row, column) {
      let find = this.steps[this.step].positions.find(
        (f) => f.row == row && f.column == column
      );
      return typeof find !== "undefined" ? true : false;
    },
    isFail(row, column) {
      if (
        this.steps[this.step].fail.row == row &&
        this.steps[this.step].fail.column == column &&
        !this.steps[this.step].fail.correct
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped lang="scss">
.pattern-block {
  background-color: #fff;
  border-radius: 32px;
  height: 76vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px;

  @media screen and (max-width: 1600px) {
    height: 70vh;
  }

  @media screen and (max-width: 1280px) {
    height: 68vh;
  }

  @media screen and (max-width: 1199px) {
    height: 68vh;
  }

  @media screen and (max-width: 1100px) {
    height: 75vh;
  }

  @media screen and (max-width: 918px) {
    height: 81vh;
  }

  @media screen and (max-width: 500px) {
    height: calc(100vh - 120px);
    padding: 10px;
  }
}
</style>